<form [formGroup]="form">
  <div class="form_content">
    <div class="obligatory">
      <mat-form-field appearance="outline">
        <mat-label>Nom de l'offre</mat-label>
        <input tyepe="text" matInput formControlName="offerName" [required]="true"
          (input)="updatePreviewOffer('offerName')" />
      </mat-form-field>
      <span *ngIf="!f.offerName.value" appChangeColorTheme attribute="color" rgba="0.6">*Champ obligatoire</span>
    </div>

    <div class="obligatory">
      <mat-form-field appearance="outline">
        <mat-label>N° Club</mat-label>
        <mat-select formControlName="clubCode" [required]="true">
          <mat-option *ngFor="let c of clubs" [value]="c.code">
            <strong>{{ c.code }}</strong> - {{ c.name }}</mat-option>
        </mat-select>
      </mat-form-field>
      <span *ngIf="userConnected.role === 'admin' && !f.clubCode.value" appChangeColorTheme attribute="color"
        rgba="0.6">*Champ obligatoire</span>
    </div>

    <div class="obligatory">
      <mat-form-field appearance="outline">
        <mat-label>Lieu de pratique *</mat-label>
        <mat-select formControlName="practicePlace">
          <mat-option *ngIf="!practicesClub?.length">
            Aucun lieu de pratique</mat-option>
          <mat-option *ngFor="let pp of practicesClub" [value]="pp">
            <strong>{{pp.label}}</strong> - {{ pp.postalCode }} {{ pp.city }} - {{ pp.box }}, {{ pp.address }}
            <!-- <strong>{{ pp.postalCode }} {{ pp.city }}</strong> - {{ pp.box }}, -->
          </mat-option>
        </mat-select>
      </mat-form-field>
      <span *ngIf="!f.practicePlace.value" appChangeColorTheme attribute="color" rgba="0.6">*Champ
        obligatoire</span>
    </div>

    <mat-form-field appearance="outline">
      <mat-label>Avantage licencié</mat-label>
      <textarea matInput formControlName="advantage" class="advantageTextarea"></textarea>
    </mat-form-field>

    <div class="obligatory">
      <h5>Phrase d'accroche*</h5>
      <angular-editor formControlName="description" [config]="editorConfig" placeholder="Phrase d'accroche"
        [required]="true" (input)="updatePreviewOffer('description')"></angular-editor>
      <span *ngIf="!f.description.value" appChangeColorTheme attribute="color" rgba="0.6">*Champ
        obligatoire</span>
    </div>

    <div>
      <h5>Ce que vous allez vivre</h5>
      <angular-editor formControlName="customerPromise" [config]="editorConfig"
        placeholder="Ce que vous allez vivre"></angular-editor>
      <i class="red" *ngIf="form.controls['customerPromise'].hasError('maxlength')">Attention vous
        dépassez le
        nombre limite de
        caractères.</i>
    </div>

    <div>
      <h5>Descriptif de l'activité</h5>
      <angular-editor formControlName="informations" [config]="editorConfig"
        placeholder="Descriptif de l'activité"></angular-editor>
    </div>

    <div>
      <h5>Nos conseils pratiques pour retirer tout le bénéfice de l’expérience</h5>
      <angular-editor formControlName="services" [config]="editorConfig"
        placeholder="Nos conseils pratiques pour retirer tout le bénéfice de l’expérience"></angular-editor>
    </div>

    <div>
      <h5>Prérequis</h5>
      <angular-editor formControlName="prerequisites" [config]="editorConfig" placeholder="Prérequis"></angular-editor>
    </div>

    <div>
      <h5>Comment compléter agréablement votre séjour</h5>
      <angular-editor formControlName="environment" [config]="editorConfig"
        placeholder="Comment compléter agréablement votre séjour"></angular-editor>
    </div>

    <mat-form-field appearance="outline">
      <mat-label>Durée</mat-label>
      <input type="text" matInput placeholder="ex: 5 demi-journées sur 1 semaine" formControlName="duration"
        (input)="updatePreviewOffer('duration')" />
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Période d'ouverture</mat-label>
      <input matInput formControlName="openingPeriod" />
    </mat-form-field>

    <div class="obligatory">
      <mat-form-field appearance="outline">
        <mat-label>Prix</mat-label>
        <input type="text" matInput formControlName="price" placeholder="ex: À partir de ..." [required]="true"
          (input)="updatePreviewOffer('price')" />
      </mat-form-field>
      <span *ngIf="!f.price.value" appChangeColorTheme attribute="color" rgba="0.6">*Champ obligatoire</span>
    </div>

    <div *ngIf="form.get('hasSession').value">
      <mat-slide-toggle class="licenceRequired" formControlName="licenceRequired" [color]="color">
        Licence obligatoire</mat-slide-toggle>
      <app-autocomplete *ngIf="form.get('licenceRequired').value && !isLoadingLicences" [control]="form.get('licence')"
        [list]="licences" label="Licence" errorMsg="Veuillez sélectionner une licence">
      </app-autocomplete>
    </div>
  </div>

  <div class="payment_offer" *ngIf="!form.get('isInternalOffer').value">
    <h4>Redirection de l'offre</h4>

    <mat-form-field appearance="outline" class="tooltip">
      <mat-label>Url offre sur le site du club</mat-label>
      <input type="text" matInput formControlName="offerClubURL" />
      <fa-icon [icon]="getFaIcon('faInfoCircle')" [matTooltip]="getTooltip('externUrlOffer')" appChangeColorTheme
        attribute="color"></fa-icon>
    </mat-form-field>
  </div>

  <div class="title_parameter" *ngIf="form.get('hasSession').value">
    <h4>Paramètres</h4>
    <div class="add_parameter" (click)="addParameter()" appChangeColorTheme attribute="color"
      *ngIf="offerParameterUpdatable">
      <fa-icon [icon]="getFaIcon('faPlus')"></fa-icon>
      Ajouter un paramètre
    </div>
  </div>

  <p *ngIf="form.get('hasSession').value && !offerParameterUpdatable" class="italic">Vous ne pouvez pas éditer/ajouter
    des
    paramètres
    sur une offre achetée ou présente dans un panier</p>

  <mat-list formArrayName="parameters" class="matList_parameters" *ngIf="form.get('hasSession').value">
    <mat-list-item *ngFor="let control of getArray('parameters').controls; index as i" [formGroupName]="i">
      <section class="parameter_field">
        <div class="trashFirstPageParam">
          <mat-checkbox [color]="color" formControlName="isFirstPage"
            matTooltip="En 1ère ou 2ème page du pdf de la session">En 1ère page</mat-checkbox>
          <fa-icon [icon]="getFaIcon('faTrashAlt')" (click)="removeParameter(i)" matTooltip="Supprimer"
            *ngIf="offerParameterUpdatable">
          </fa-icon>
        </div>

        <app-autocomplete [control]="control.get('param')" [list]="filteredParameters" label="Paramètre"
          errorMsg="Veuillez sélectionner un paramètre" [disabled]="!offerParameterUpdatable"
          [hasTooltip]="control.value?.param?.values ? control.value?.param?.values === 'noValue' ? false : true : false"
          [tooltipText]="control.value?.param?.values ? getTooltipText(control.value?.param?.values, control.value?.param?.type) : ''">
        </app-autocomplete>
      </section>
    </mat-list-item>
  </mat-list>

  <h4>Univers</h4>
  <div class="universes" *ngIf="universes">
    <mat-checkbox *ngFor="let u of universes" [color]="color" [checked]="u.checked" (change)="addOrDeleteUniverse(u)">{{
      u?.universeName }}</mat-checkbox>
  </div>

  <div class="tag_title">
    <h4>Tags</h4>
    <span>*Champ requis</span>
  </div>
  <div class="tags" *ngIf="universesSelected.length > 0">
    <mat-accordion [multi]="false">
      <ng-container *ngFor="let t of filteredTags">
        <app-mat-accordion-tree [tags]="t" [allComplete]="t.completed"></app-mat-accordion-tree>
      </ng-container>
    </mat-accordion>
  </div>

  <p *ngIf="universesSelected.length === 0">Veuillez sélectionner au moins un univers pour pouvoir choisir des
    tags.
  </p>

  <h4>Tags principaux</h4>
  <div class="main_tags" *ngIf="universesSelected.length > 0">
    <mat-form-field appearance="outline">
      <mat-label>Premier tag</mat-label>
      <input type="text" matInput formControlName="firstMainTag" [matAutocomplete]="auto"
        (ngModelChange)="filterMainTags('first', f.firstMainTag)" />
      <mat-autocomplete #auto="matAutocomplete">
        <mat-option *ngFor="let t of tagsSelected" [value]="t.tagName">
          {{ t.tagName }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
    <mat-form-field appearance="outline" *ngIf="f.firstMainTag.value">
      <mat-label>Second tag</mat-label>
      <input type="text" matInput formControlName="secondMainTag" [matAutocomplete]="auto"
        (ngModelChange)="filterMainTags('second', f.secondMainTag)" />
      <mat-autocomplete #auto="matAutocomplete">
        <mat-option *ngFor="let t of tagsSelectedSecondMainTag" [value]="t.tagName">
          {{ t.tagName }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
    <mat-form-field appearance="outline" *ngIf="f.firstMainTag.value && f.secondMainTag.value">
      <mat-label>Troisième tag</mat-label>
      <input type="text" matInput formControlName="thirdMainTag" [matAutocomplete]="auto"
        (ngModelChange)="filterMainTags('third', f.thirdMainTag)" />
      <mat-autocomplete #auto="matAutocomplete">
        <mat-option *ngFor="let t of tagsSelectedThirdMainTag" [value]="t.tagName">
          {{ t.tagName }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
  </div>

  <p *ngIf="universesSelected.length === 0">Veuillez sélectionner au moins un univers pour pouvoir choisir des
    tags
    principaux.</p>


  <!-- Images -->

  <h4>Image principale</h4>

  <div class="upload_img">
    <div class="upload">
      <div class="input">
        <div class="input_uplaod_perso" appChangeColorTheme attribute="bgc">
          <fa-icon [icon]="getFaIcon('faUpload')"></fa-icon>
          <p>Importer une image principale</p>
        </div>
        <p class="size_max">Taille max. 300kB, privilégier format paysage 16/9</p>
        <input type="file" formControlName="image" class="input_default_file"
          (input)="updatePreviewOffer('image', $event)" />
      </div>

      <div class="input_uplaod_perso" appChangeColorTheme attribute="bgc" (click)="openDialogChooseImage()"
        *ngIf="f.clubCode.value">
        <fa-icon [icon]="getFaIcon('faArrowAltCircleUp')"></fa-icon>
        <p>Choisir une image principale parmis celles du club</p>
      </div>

      <div [ngSwitch]="mode">
        <ng-container *ngSwitchCase="'add'">
          <div class="file_name" *ngIf="file">
            <fa-icon [icon]="getFaIcon('faFile')" appChangeColorTheme attribute="color"></fa-icon>
            {{ this.file?.name }}
          </div>
        </ng-container>

        <div class="file_name" *ngSwitchCase="'edit'">
          <fa-icon [icon]="getFaIcon('faFile')" appChangeColorTheme attribute="color"></fa-icon>
          {{ this.file ? this.file?.name : this.offerPreview?.image }}
        </div>
      </div>
    </div>
    <div class="experience_photo">
      <mat-form-field appearance="outline">
        <mat-label>Photo expérience</mat-label>
        <input type="text" matInput formControlName="photoExperience" />
        <mat-error>Maximum 50 caractères</mat-error>
      </mat-form-field>

    </div>
  </div>
</form>